import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';

import s from 'components/loadingBar/loadingBar.sss';

export default class LoadingBar extends Component {
	render() {
		return <div {...this.props} class={joinClasses(s.loading, this.props.class)} />;
	}
}